export const get_currentCompanyId = ({ rootGetters }) => {
  let currentCompanyId;
  if (rootGetters.getCurrentCompany) {
    currentCompanyId = rootGetters.getCurrentCompany.id;
  } else if (rootGetters["me/userData"].companydb) {
    currentCompanyId = rootGetters["me/userData"].companydb.id;
  }
  return currentCompanyId;
};

export function copyToClipboard(value) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(value).catch(err => {
      console.log('Error copiando al portapapeles', err);
    });
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(textarea);
    }
  }
}